// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import ServiceIntervalStatuses from '../state/service-interval-statuses';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const MaintenancePlanServiceIntervalStatusCriteria = props => {

    const statusesSelectionMessage = props.serviceIntervalStatuses.selected.length ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (

        <div className='maintenance-plan-service-interval-status-criteria'>
            <CheckboxListWithLabel
                className='service-interval-status-criteria'
                initialState={createHashMap(props.serviceIntervalStatuses.selected, 'key')}
                isRequired={false}
                label='SERVICE_INTERVAL_STATUS'
                list={addCollectionLabels(props.serviceIntervalStatuses.allowed, 'value')}
                onChange={props.onHandleServiceIntervalStatusesSelectChange}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.onHandleSelectAllServiceIntervalStatuses}
                type='button'
            >
                <FormattedMessage id={statusesSelectionMessage}/>
            </button>
        </div>

    );

};

MaintenancePlanServiceIntervalStatusCriteria.displayName = 'MaintenancePlanServiceIntervalStatusCriteria';
MaintenancePlanServiceIntervalStatusCriteria.propTypes = {
    onHandleSelectAllServiceIntervalStatuses: PropTypes.func.isRequired,
    onHandleServiceIntervalStatusesSelectChange: PropTypes.func.isRequired,
    serviceIntervalStatuses: PropTypes.instanceOf(ServiceIntervalStatuses).isRequired
};

export default MaintenancePlanServiceIntervalStatusCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-service-interval-status-criteria.js